<template>
  <v-container
    style="
      position: fixed;
      z-index: 999;
      bottom: 0;;
      text-align: end;
      width: 60px;
    "
  >
    <div class="text-center">
      <v-btn
      class="mx-2"
      fab
      dark
      medium
      color="primary"
      @click="generateCsv()"
      >
        <v-icon dark>
          download
        </v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import {firestore} from '@/plugins/firebase'
export default {
  props: ['timeRange', 'organizationId', 'irrigationOrders1', 'irrigationOrders2', 'equipmentsData1', 'equipmentsData2'],
  data () {
    return {
    }
  },
  methods: {
    downloadCsv (csvStr, organizationName, fromDate, toDate) {
      const csvFileText = `data:text/csvcharset=utf-8,${csvStr}`
      let encodedUri = encodeURI(csvFileText)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', `${organizationName}-${fromDate.getDate()}-${fromDate.getMonth() + 1}-${fromDate.getFullYear()}--${toDate.getDate()}-${toDate.getMonth() + 1}-${toDate.getFullYear()}-dashboard.csv`)
      document.body.appendChild(link)
      link.click()
    },
    generateCsv () {
      firestore.then(db => {
        db.collection('app/v1/organizations').doc(this.organizationId).get().then(doc => {
          let organizationName = doc.data().name
          let fromDate = new Date(this.timeRange.from)
          let fromHour = fromDate.toLocaleString('en-AR', { hour: 'numeric', minute: 'numeric', hour12: true })
          let toDate = new Date(this.timeRange.to)
          let toHour = toDate.toLocaleString('en-AR', { hour: 'numeric', minute: 'numeric', hour12: true })
          let csvStr = ''
          csvStr += `${this.$t('DownloadData.client')}: ${organizationName}\n`
          csvStr += `${this.$t('DownloadData.periodCovered')}: ${fromHour} ${fromDate.getDate()}/${fromDate.getMonth() + 1}/${fromDate.getFullYear()} ${this.$t('DownloadData.to')} ${toHour} ${toDate.getDate()}/${toDate.getMonth() + 1}/${toDate.getFullYear()}\n`
          csvStr += `${this.$t('DownloadData.irrigationOrder')}${this.$t('DownloadData.device')}${this.$t('DownloadData.lot')}${this.$t('DownloadData.startDate')}${this.$t('DownloadData.endDate')}${this.$t('DownloadData.mm')}${this.$t('DownloadData.theoricHoursShort')}${this.$t('DownloadData.accumulatedHoursShort')}\n`
          this.irrigationOrders1.forEach((elem) => {
            csvStr += `${elem.irrigationOrderId}${elem.deviceName}${elem.plotName}${elem.from}${elem.to}${elem.mm ? elem.mm : ''}${elem.theoricHours ? elem.theoricHours : ''}${elem.diffTimeHours}\n`
          })
          this.irrigationOrders2.forEach((elem) => {
            csvStr += `${elem.irrigationOrderId}${elem.deviceName}${elem.plotName}${elem.from}${elem.to}${elem.mm ? elem.mm : ''}${elem.theoricHours ? elem.theoricHours : ''}${elem.diffTimeHours}\n`
          })
          csvStr += '\n\n'
          csvStr += `${this.$t('DownloadData.device')}${this.$t('DownloadData.accumulatedHours')}${this.$t('DownloadData.theoricHours')}\n`
          for (let i = 0; i < this.equipmentsData1.theoricHours.length; i++) {
            csvStr += `${this.equipmentsData1.deviceNames[i]}`
            csvStr += `${this.equipmentsData1.accumulatedHours[i] ? this.equipmentsData1.accumulatedHours[i] : ''}`
            csvStr += `${this.equipmentsData1.theoricHours[i] ? this.equipmentsData1.theoricHours[i] : ''}\n`
          }
          for (let i = 0; i < this.equipmentsData2.theoricHours.length; i++) {
            csvStr += `${this.equipmentsData2.deviceNames[i]}`
            csvStr += `${this.equipmentsData2.accumulatedHours[i] ? this.equipmentsData2.accumulatedHours[i] : ''}`
            csvStr += `${this.equipmentsData2.theoricHours[i] ? this.equipmentsData2.theoricHours[i] : ''}\n`
          }
          this.downloadCsv(csvStr, organizationName, fromDate, toDate)
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// DownloadData.vue?1a7731ea